$(document).on('turbolinks:load', function() {
  $('.user-profile__section').on('change', '#phone-notification, #email-notification', function() {
    $.get($(this).data('url'));
  });
});